import React from "react";
import { useLocation } from "react-router-dom";
import { WHATSAPP_URL } from "../lib/constants";

const HIDDEN_ROUTES = [
    "/brochure",
    "/brochure-corporate",
    "/brochure-gym",
    "/brochure-realestate",
    "/brochure-athletes",
    "/brochure-equine",
    "/brochure-pets",
    "/brochure-yacht",
    "/brochure-bvlgari",
    "/resume",
    "/cover-letter",
    "/application",
    "/cover-letter-portable",
    "/application-portable",
    "/sunrise-pitch",
];

// Floating circular WhatsApp button — fixed bottom-right, all pages.
export const FloatingWhatsApp = () => {
    const { pathname } = useLocation();
    if (HIDDEN_ROUTES.includes(pathname)) return null;
    return (
        <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Reserve via WhatsApp"
            data-testid="floating-whatsapp-btn"
            style={{
                position: "fixed",
                bottom: 24,
                right: 24,
                width: 60,
                height: 60,
                borderRadius: "50%",
                backgroundColor: "#c9a227",
                color: "#0a0a0a",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 90,
                boxShadow:
                    "0 8px 28px rgba(201,162,39,0.35), 0 0 0 1px rgba(201,162,39,0.4)",
                textDecoration: "none",
                transition: "transform 0.25s ease, box-shadow 0.25s ease",
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.08)";
                e.currentTarget.style.boxShadow =
                    "0 12px 40px rgba(201,162,39,0.55), 0 0 0 1px #c9a227";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow =
                    "0 8px 28px rgba(201,162,39,0.35), 0 0 0 1px rgba(201,162,39,0.4)";
            }}
        >
            {/* WhatsApp icon (inline SVG, no extra deps) */}
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
            >
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12.017 0C5.396 0 .029 5.367.029 11.988c0 2.115.553 4.182 1.601 6.005L0 24l6.155-1.616c1.761.96 3.745 1.466 5.762 1.466C18.624 23.85 24 18.483 24 11.862 24 5.241 18.633 0 12.017 0z" />
            </svg>
        </a>
    );
};

export default FloatingWhatsApp;
